<ng-container *ngIf="!isShowRVC">
  <div class="main">
    <p class="repair-header">{{'Repair Qualification'|translate}}</p>
    <div class="table ">
      <table style="width: 100%">
        <thead>
          <tr>
            <th>{{'Repair'|translate}}</th>
            <th>{{'Indictment'|translate}}</th>
            <th>{{'Control'|translate}}</th>
            <th>{{'Repair'|translate}} ({{repair.repair}})</th>
            <th>{{'Post Repair'|translate}} ({{repair.postRepair}})</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{repair.componentName}}</td>
            <td *ngIf="repair.indictment == 'manualTechnician'">{{'Technician'|translate}}</td>
            <td *ngIf="repair.indictment !== 'manualTechnician'">{{repair.indictment|translate}}</td>
            <td>
              <button class="buttons" *ngIf="!isControl" (click)="view(1)">{{'View'|translate}}</button>
              <button class="buttons-disabled" *ngIf="isControl" disabled readonly>{{'DONE'|translate}}</button>
            </td>
            <td>
              <button class="buttons" *ngIf="isRepair && repairCount > 0"
                (click)="view(2)">{{repairBtnState|translate}}</button>
              <button class="buttons-disabled" *ngIf="!isRepair && repairCount > 0" disabled
                readonly>{{repairBtnState|translate}}</button>
              <p *ngIf="repair.repair == 0">--</p>
            </td>
            <td>
              <button class="buttons" *ngIf="isPostRepair && postRepairCount > 0"
                (click)="view(3)">{{postRepairBtnState|translate}}</button>
              <button class="buttons-disabled" *ngIf="!isPostRepair && postRepairCount > 0" disabled
                readonly>{{postRepairBtnState|translate}}</button>
              <p *ngIf="repair.postRepair == 0">--</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="isShowPartsKit" class="parts_table_o">
      <tr class="repair-header"> {{'Repair Information'|translate}} </tr>
      <div *ngIf="!noWarratyCode">
        <div class="repair-header subhead"> {{'Parts Required'|translate}} </div>
        <div class="table">
          <table style="width: 100%;">
            <thead>
              <tr>
                <th>{{'FINIS Code'|translate}}</th>
                <th>{{'Parts Number'|translate}}</th>
                <th>{{'Quantity'|translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let kit of listofpartskit">
                <td>{{kit.partNumber}}</td>
                <td>{{kit.realPartNumber}}</td>
                <td>{{kit.quantity}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="noWarratyCode">
        <div class="repair-header subhead"> This repair will require a parts kit ({{partsKit}}). Please
          follow the kit request process applicable for your market. </div>
        <div class="repair-header">{{'Warranty Kit'|translate}}</div>
        <div class="repair-header subhead">{{'FINIS Code'|translate}}: {{warrantyKitCode}}</div>
        <div class="repair-header subhead">{{'Quantity'|translate}}: {{partsquantity}}</div>
        <div *ngIf="!casualPartEmpty" class="repair-header">{{'Claim Coding'|translate}}</div>
        <div *ngIf="!casualPartEmpty" class="repair-header subhead">Casual Part: {{casualPart}}</div>
      </div>
    </div>
    <div class="repair-error-msg" *ngIf="isControl && repair.repair == 0 && repair.postRepair == 0"></div>
    <button *ngIf="isShowRepairComplete" class="buttons repair-btn" (click)="navigateToStartDiag()">{{'REPAIR
      COMPLETE'|translate}}</button>
  </div>
</ng-container>
<div id="overlay" *ngIf="viewRepairQualification">
  <span id="nav-spinner">
    <img src="assets/images/ajax-loader.gif" width="80" height="80">
  </span>
</div>
<ng-container *ngIf="isShowRVC">
  <div class="d-flex justify-content-end align-items-center mb-3" style="width: 95%; margin-top: 5px;">
    
    <i class="fa fa-file-pdf-o me-3" 
       (click)="downloadPageAsPdf()" 
       title="Download PDF"
       style="cursor: pointer; font-size: 1.3rem; color: #d32f2f;">
    </i>
    <i class="fa fa-print" 
       (click)="printPageNative()" 
       title="Print Page"
       style="cursor: pointer; font-size: 1.3rem; color: #003399;">
    </i>
  </div>

  <div class="container">
    <div class="left-content">
      <div style="margin-left: 1rem">
        <div style="margin-top:34px;"><span class="repair-rvc">{{'Faulty Component/Repair'|translate}}:</span><span
            class="repair-rvc1">
            {{repair.componentName}}</span></div>
        <div *ngIf="showNoRVCInfo"><span class="repair-rvc">{{'Repair Validation Code'|translate}}:</span><span
            class="repair-rvc2">{{repair.rvcCode|translate}}</span>&nbsp;&nbsp;</div>
        <div *ngIf="!showNoRVCInfo"><span class="repair-rvc">{{'Repair Validation Code'|translate}}:</span><span
            class="repair-rvc2">{{repair.rvcCode|translate}}</span></div>
        <div><span class="repair-rvc">{{'Repair Procedures'|translate}}:</span><span
            class="repair-rvc1">{{repair.repair}}</span></div>
        <div><span class="repair-rvc">{{'Post Repair Procedures'|translate}}:</span><span
            class="repair-rvc1">{{repair.postRepair}}</span>
        </div>
        <input class="repair-cont-btn" type="submit" (click)="callRepair()" name="add" value="{{'Continue'|translate}}">
      </div>
    </div>
    <div class="right-notes" *ngIf="showNoRVCInfo">
      <h4>{{'RVC_Header'|translate}}</h4>
      <p> 1. {{'NoRVC_Msg'|translate}}.<br>
        2. {{'RVCMsg_Contact_Helpdesk'|translate}}
      </p>
    </div>
    <div class="right-notes" *ngIf="showCustomerPaidDesc">
      <h4>{{'RVC_Header'|translate}}</h4>
      <p> {{'Customer_Paid_Description'| translate}} </p>
    </div>
  </div>
</ng-container>
<ng-template #noRVCMsgInfo let-modal>
  <div class="container version">
    <div class="row popup-header" style="margin-top: 0%;">
      <div class="pull-left">{{'Information'|translate}}</div>
      <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
          *ngIf="!isButtonEnabled" (click)="modal.dismiss('noRVCMsgInfo')"></i></div>
    </div>
    <div>
      <label class='msg-body'>
        <p class="norvg-msg">{{'norvc_req_description_msg' | translate}}</p>
      </label>
    </div>
    <hr class="hr-line1">
    <div class="popup-footer">
      <button type="button" class="btn btn-primary mr-3 pull-right confirm" name="confirm" [disabled]="isButtonEnabled"
        (click)="modal.dismiss('noRVCMsgInfo')">{{'Confirm'|translate}}</button>
    </div>
  </div>
</ng-template>